import { render } from "./ProfileContent.vue?vue&type=template&id=6e3f1847"
import script from "./ProfileContent.vue?vue&type=script&lang=js"
export * from "./ProfileContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__